import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../Services/AuthService/AuthService';
import { fetchUniversity, fetchUniversityDomain } from '../Services/University/UniversityService';
import Footer from "../components/Footer/Footer";
import piri_logo from '../assets/images/about/piri_logo.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

export default function RegisterPage() {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        isimsoyisim: '',
        email: '',
        password: '',
        tel: '',
        fakulte: '',
        bolum: '',
        temelalan: '',
        yoksisid: '',
        universiteid: '',
        emailUsername: '',
        emailDomain: ''
    });


    const [error, setError] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate();

    const [universities, setUniversities] = useState([]);
    const [domainList, setDomainList] = useState([]);

    useEffect(() => {
        const loadUniversities = async () => {
            try {
                const response = await fetchUniversity();
                setUniversities(response.data);

            } catch (err) {
                console.error(err)
            }
        };

        loadUniversities();
    }, []);

    useEffect(() => {
        const loadUniversitiesDomain = async () => {
            try {
                const response = await fetchUniversityDomain(formData.universiteid);
                setDomainList(response.data);

            } catch (err) {
                console.error(err)
                setDomainList([]);
            }
        };

        loadUniversitiesDomain();
    }, [formData.universiteid]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isChecked) {
            setError('Kullanım şartnamesini onaylamanız gerekiyor.');
            return;
        }

        try {
            const combinedEmail = `${formData.emailUsername}${formData.emailDomain}`;
            const updatedFormData = {
                ...formData,
                email: combinedEmail,
            };
          const response = await register(updatedFormData);
          toast.success(response.status);
        setTimeout(() => {
            navigate('/');
        }, 3000);
        } catch (err) {
            toast.error(err?.response?.data?.status);
            setError('Giriş yapılırken bir hata oluştu');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    return (
        <div className="min-h-screen bg-[#f5f6f6] flex items-center justify-center">
            <div className="w-full max-w-5xl bg-white shadow-lg rounded-lg p-3">



                {/* Right Section */}
                <div className=" bg-white p-8">
                    <div className="flex justify-center mb-8">
                        <img
                            src={piri_logo}
                            alt="Piri AI Logo"
                            className="w-24"
                        />
                    </div>

                    {error && (
                        <div className="mb-4 p-2 bg-red-100 text-red-600 rounded text-sm">
                            {error}
                        </div>
                    )}

                    <p className="text-sm text-gray-600 mt-2">
                        
                        {t('Eğer Piri Üyeliğiniz varsa kayıt olmanıza gerek yoktur. Piri üyelik bilgileri ile giriş yapabilirsiniz.')}
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid grid-cols-2 gap-4">
                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('İsim Soyisim')}
                                </label>
                                <input
                                    type="text"
                                    name="isimsoyisim"
                                    value={formData.isimsoyisim}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder= {t('Adınız ve Soyadınız')}
                                    required
                                />
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Şifre')}
                                </label>
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder={t('Şifrenizi Girin')}
                                    required
                                />
                            </div>


                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Üniversite')}
                                </label>
                                <select
                                    name="universiteid"
                                    value={formData.universiteid}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md bg-white"
                                    required
                                >
                                    <option value="" disabled>
                                    {t('Üniversite Seçin')}
                                    </option>
                                    {universities.map((uni) => (
                                        <option key={uni.id} value={uni.uni_id}>
                                            {uni.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Email')} 
                                </label>
                                <div className="flex mt-1">
                                    <input
                                        type="text"
                                        name="emailUsername"
                                        value={formData.emailUsername || ''}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            // '@' karakterini kontrol et ve engelle
                                            if (!newValue.includes('@')) {
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    emailUsername: newValue,
                                                }));
                                            }
                                        }}

                                        className="block w-2/3 px-3 py-2 border border-[#3c4f58] rounded-l-md"
                                        placeholder=""
                                        required
                                    />
                                    <select
                                        name="emailDomain"
                                        value={formData.emailDomain || '@kurumunuz.edu.tr'}
                                        onChange={(e) =>
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                emailDomain: e.target.value,
                                            }))
                                        }
                                        className="block w-1/3 px-3 py-2 border border-[#3c4f58] rounded-r-md bg-white"
                                        required
                                    >
                                        <option value="" selected>
                                        {t('Domain Seçin')}  
                                        </option>
                                        {domainList.map((item, index) => (

                                            <option key={index} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Telefon')} {t('(İsteğe Bağlı)')}
                                </label>
                                <input
                                    type="tel"
                                    name="tel"
                                    value={formData.tel}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder="Telefon numaranızı girin"

                                />
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Fakülte')} {t('(İsteğe Bağlı)')}
                                </label>
                                <input
                                    type="text"
                                    name="fakulte"
                                    value={formData.fakulte}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder="Fakülte adını girin"

                                />
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Bölüm')} {t('(İsteğe Bağlı)')}
                                </label>
                                <input
                                    type="text"
                                    name="bolum"
                                    value={formData.bolum}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder="Bölüm adını girin"

                                />
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('Temel Alanı')} {t('(İsteğe Bağlı)')}
                                </label>
                                <input
                                    type="text"
                                    name="temelalan"
                                    value={formData.temelalan}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder="Temel alan bilgisi girin"

                                />
                            </div>

                            <div className="mt-1">
                                <label className="block text-sm font-medium text-[#3c4f58] text-left">
                                {t('YÖKSİS ID (İsteğe Bağlı)')}
                                </label>
                                <input
                                    type="text"
                                    name="yoksisid"
                                    value={formData.yoksisid}
                                    onChange={handleChange}
                                    className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                    placeholder="YÖKSİS ID"

                                />
                            </div>

                        </div>
                        <div className="mt-1 flex items-center">
                            <input
                                type="checkbox"
                                id="termsCheckbox"
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                                className="mr-2"
                                required
                            />
                            <label htmlFor="termsCheckbox" className="text-sm text-[#3c4f58]">
                                <span onClick={() => setModalOpen(true)}
                                      className="text-blue-500 cursor-pointer underline">
                                   {t('Kullanım Şartnamesi')}  
                                </span>
                                'ni okudum, onaylıyorum.
                            </label>
                        </div>

                        <p className="text-sm text-gray-600 mt-2">
                        {t('Üyelik Formunu Tamamladıktan Sonra, Üyeliğinizi aktifleştirmek için mailinize gönderilen linke tıklayınız.')}
                        </p>

                        <button
                            type="submit"
                            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-[#3c4f58] hover:bg-[#2c3e48]"
                        >
                             {t('Kayıt Ol')}
                        </button>
                    </form>

                    <div className="mt-6 text-center space-y-4">

                        <a
                            href="/login"
                            className="text-[#3c4f58] hover:text-[#2c3e48]"
                        >
                            {t('Hesabınız Zaten var mı? Hemen oturum açın.')} 
                        </a>
                    </div>
                </div>
            </div>


            {modalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl">
                        <h2 className="text-lg font-bold mb-4">Kullanım Şartnamesi</h2>
                        <div className="modal-body text-sm text-left" style={{ textAlign: 'justify', color: '#626262' }}>
                            <p>
                                <font style={{ fontWeight: 600, color: '#000' }}>1. Arama Hizmeti</font> <br />
                                &nbsp;&nbsp;&nbsp;A. Akademik Keşif Aracı, kullanıcılara akademik aramalarında yardımcı olmak için bir hizmet
                                sunmaktadır. <br />
                                &nbsp;&nbsp;&nbsp;B. Kullanıcılar, kurumun abonelik sağladığı bir hesapla giriş yaparak arama yapabilir ve
                                sonuçları<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;görüntüleyebilir.
                            </p>
                            <br />
                            <p>
                                <font style={{ fontWeight: 600, color: '#000' }}>2. Veri Saklama ve Paylaşımı </font> <br />
                                &nbsp;&nbsp;&nbsp;A. Kullanıcıların arama verileri, Akademik Keşif Aracı tarafından kaydedilebilir. <br />
                                &nbsp;&nbsp;&nbsp;B. Kurum yöneticileri, kullanıcıların arama verilerine erişebilir ve bunları analiz etmek
                                veya hizmeti<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;iyileştirmek için kullanabilir. <br />
                                &nbsp;&nbsp;&nbsp;C. Kurum yöneticileri, kullanıcının rızası olmadan arama verilerini üçüncü taraflarla
                                paylaşamaz.<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ancak, kullanıcının rızası ile anonimleştirilmiş veya toplu
                                olarak işlenmiş verileri paylaşabilirler. <br />
                                &nbsp;&nbsp;&nbsp;D. Kullanıcılar, kurum yöneticilerine arama verilerinin silinmesi talebinde
                                bulunabilir.<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bu durumda, kurum yöneticileri kullanıcının verilerini
                                silmekle yükümlüdür.
                            </p>
                            <br />
                            <p style={{ fontWeight: 600, color: '#000' }}>
                                3. Piri Keşif Aracı ve sahibi olduğu INSERES Eğitim şirketi 6698 Sayılı Kişisel Verilerin Korunması
                                Kanununa uymayı tahahhüt eder.
                            </p>
                            <br />
                            <p>
                                <font style={{ fontWeight: 600, color: '#000' }}>4. Kişisel Verilerin İşlenmesi </font> <br />
                                &nbsp;&nbsp;&nbsp;A. Akademik Keşif Aracı, kullanıcıların kişisel verilerini sadece hizmetin sağlanması
                                amacıyla işleyebilir. <br />
                                &nbsp;&nbsp;&nbsp;B. Kullanıcıların kişisel verileri, yasalara uygun olarak ve gerekli güvenlik önlemleri
                                alınarak işlenir. <br />
                                &nbsp;&nbsp;&nbsp;C. Kullanıcıların kişisel verileri, yalnızca ilgili kullanıcının açık rızası veya yasal bir
                                zorunluluk olması<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;durumunda üçüncü taraflara aktarılır.
                            </p>
                            <br />
                            <p>
                                <font style={{ fontWeight: 600, color: '#000' }}>5. Kişisel Verilerin Güvenliği</font> <br />
                                &nbsp;&nbsp;&nbsp;A. Akademik Keşif Aracı, kullanıcıların kişisel verilerinin güvenliğini sağlamak için
                                uygun teknik ve<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;organizasyonel önlemler alır. <br />
                                &nbsp;&nbsp;&nbsp;B. Veri güvenliği için yetkilendirilmemiş erişimlerin engellenmesi, veri bütünlüğünün
                                korunması ve veri<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;kaybının önlenmesi gibi önlemler alınır. <br />
                                &nbsp;&nbsp;&nbsp;C. Kişisel verilere erişimi olan personel, gizlilik taahhütnamesi imzalar ve verilere
                                sadece iş gereklilikleri<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;çerçevesinde erişebilir.
                            </p>
                        </div>
                        <div className="flex justify-end mt-1">
                            <button
                                onClick={() => setModalOpen(false)}
                                className="px-4 py-2 bg-[#3c4f58] text-white rounded-md hover:bg-[#2c3e48]"
                            >
                                Kapat
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
            <ToastContainer />
        </div>


    );
}